import { useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'
import { FeatureFlagKeys } from '../store/Constants'

const useLaunchdarkly = () => {
  const { flags } = useContext(ConfigContext)

  const pswApiClientId = flags?.['olex-psw-api-client-id']
  const supportCalloutMapping = flags?.[FeatureFlagKeys.supportCalloutMapping]

  return {
    pswApiClientId,
    supportCalloutMapping
  }
}

export default useLaunchdarkly
